module.exports = __webpack_public_path__ + "static/23-5f2385442fc845b47ae0de411fea1c39.jpg";